module.exports = __webpack_public_path__ + "img/finland-ill-defined-causes-male.86cbc474.png";